import { useQueryClient } from '@tanstack/react-query';

import {
  getApiV1SerieSerieidLangsQueryOptions,
  useDeleteApiV1SerieSerieidLangsId,
} from '@/shared/api/generated';

/**
 * Hook para excluir um Idioma da Série.
 *
 * Envolve o mutation gerado pelo Kubb para `DELETE /api/v1/serie/{serieId}/langs/{id}`
 * e invalida o cache da listagem após a exclusão bem-sucedida.
 *
 * @param serieId - ID da série
 *
 * @example
 * ```tsx
 * const deleteSerieLang = useDeleteSerieLang(serieId);
 * deleteSerieLang.mutate({ serieId, id: 12 });
 * ```
 */
export function useDeleteSerieLang(serieId: number) {
  const queryClient = useQueryClient();

  return useDeleteApiV1SerieSerieidLangsId({
    mutation: {
      onSuccess: () => {
        void queryClient.invalidateQueries(getApiV1SerieSerieidLangsQueryOptions(serieId));
      },
    },
  });
}
